/* eslint-disable @typescript-eslint/no-explicit-any */

import jwt_decode from "jwt-decode";

import { getAccessToken } from "@/helpers/auth-helpers";
import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IDecodedToken } from "@/interfaces/auth.interfaces";
import campaignImageService from "@/services/campaign-image.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateCampaignImageProps = {
  formData: FormData;
} & RequestsProps;

export type UseCreateCampaignImageReturn = {
  create: (props: CreateCampaignImageProps) => Promise<any | void>;
} & UseLoadingReturn;

const useCreateCampaignImage = (): UseCreateCampaignImageReturn => {
  const accessToken = getAccessToken();

  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<FormData>({
    operation: (formData) => {
      if (!accessToken) {
        throw new Error("Access token is undefined");
      }

      const decodedToken: IDecodedToken = jwt_decode(accessToken);
      const customerId = decodedToken.CustomerId;

      return campaignImageService.create(formData, accessToken, customerId);
    },
  });

  const createCampaignImageWithResult = async (props: CreateCampaignImageProps): Promise<any> => {
    const imageResult = await create(props);
    return imageResult;
  };

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create: createCampaignImageWithResult,
  };
};

export default useCreateCampaignImage;
